import { TYPE_BOOLEAN } from './input-types';

export const id = 'labelPrinted';
export const apiKey = 'isLabelPrinted';
export const type = TYPE_BOOLEAN;

export const labelPrinted = {
  id,
  apiKey,
  type,
};
